import {CardConfigModuleConfiguration} from "./CardConfigModuleConfiguration";
import {CardConfigComponent} from "./component/card-config.component";

CardConfigModuleConfiguration.createNewModule()
    .directive('cardConfig', CardConfigComponent.directive);